'use client';

import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';
import { cn } from '@/utils/cn-tw-merge';
import { useWhatsappLinkWithAnalytics } from '@/hooks/use-whatsapp/use-whatsapp-link-with-analytics.hook';
import { phonePatientSac } from '@/utils/consts/sac.consts';
import { ButtonColor, ButtonVariant } from '@/components/ui/button/button.types';
import { Link } from '@/components/ui/link/link.component';
import { scheduleDefaultWhatsappMessage } from '@/utils/consts/cta-whatsapp-messages.consts';
import { AnalyticsEnumKeyType } from '@/types/enums/analytics/analytics.enum';

interface AssistedPurchaseScheduleButtonProps extends React.ButtonHTMLAttributes<HTMLAnchorElement> {
  className?: string;
  variant?: ButtonVariant;
  color?: ButtonColor;
  ['data-analytics-event']?: AnalyticsEnumKeyType;
  from?: string;
  sessionName?: string;
}

export const AssistedPurchaseScheduleButton = ({ className, variant = 'secondary', color, 'data-analytics-event': analyticsEventName, from, sessionName, ...rest }: AssistedPurchaseScheduleButtonProps) => {
  const assistedPurchaseUrl = useWhatsappLinkWithAnalytics(phonePatientSac, scheduleDefaultWhatsappMessage)?.url;

  return (
    <Link prefetch={false} target="_blank" href={assistedPurchaseUrl} className="w-full" {...rest}>
      <Button
        data-testid={DataTestIdEnum.CITY_ASSISTED_PURCHASE_BUTTON}
        variant={variant}
        color={color}
        startIcon={faWhatsapp}
        className={cn('h-12', className)}
        data-analytics-event={analyticsEventName}
        data-analytics-properties={JSON.stringify({
          secao_origem: from,
          nome_secao: sessionName,
        })}
      >
        Agendar com atendente
      </Button>
    </Link>
  );
};
